import { Container } from '@cgs/wge';
import { IconsSoundModel } from '../../reels_engine/icons_sound_model';
import { RESOURCES_COMPONENT_TOKEN } from '../../type_definitions';
import { ResourcesComponent } from './resources_component';

export class IconsSoundModelComponent {
  public iconsSoundModel: IconsSoundModel;

  constructor(
    container: Container,
    { maxIconId = 60 }: { maxIconId?: number } = { maxIconId: 60 }
  ) {
    const resourcesComponent = container.resolve<ResourcesComponent>(RESOURCES_COMPONENT_TOKEN);
    this.iconsSoundModel = new IconsSoundModel(resourcesComponent.sounds, maxIconId);
  }
}
